import React from 'react';
import { useWatch } from 'react-hook-form';
import isNil from 'lodash/isNil';
import {
  OperandType,
  RelationalOperatorKey,
} from '../../../../../../utils/apollo/graphqlSchema';
import {
  castToFieldFragment,
  IPredicateFormFieldPath,
} from '../../../../types';
import { InputField } from '../../../../../Form';
import useFilterWidgetFormContext from '../../../../utils/useFilterWidgetFormContext';
import OperandValues from './OperandValues';
import OperandFields from './OperandFields';
import { getPredicateFormFieldPath } from '../../../../utils/formPath';

interface IProps {
  formPath: IPredicateFormFieldPath;
}

const PredicateOperands = ({ formPath }: IProps) => {
  const { control } = useFilterWidgetFormContext();

  const fieldPath = getPredicateFormFieldPath(formPath);

  const selectedField = useWatch({
    name: `${fieldPath}.field`,
    control,
  });

  const selectedRelOp = useWatch({
    name: `${fieldPath}.relOp`,
    control,
  });

  const selectedOperandType = useWatch({
    name: `${fieldPath}.operand.type`,
    control,
  });

  const isValueOperand = selectedOperandType === OperandType.Value;

  if (isNil(selectedField) || isNil(selectedRelOp)) {
    return (
      <InputField
        placeholder={isValueOperand ? 'Value' : 'Field'}
        disabled={true}
      />
    );
  }

  if (isValueOperand) {
    return (
      <OperandValues
        selectedField={castToFieldFragment(selectedField)}
        selectedRelOp={selectedRelOp}
        formPath={formPath}
      />
    );
  }

  return (
    <OperandFields
      formPath={formPath}
      isBetween={selectedRelOp.key === RelationalOperatorKey.Between}
    />
  );
};

export default PredicateOperands;
